import styled from "styled-components"
import { BLACK, GREY, HEADER_HEIGHT, SCROLL_WIDTH, WHITE } from "@root/common"


const PlotGraphMenuStyled = styled.div`
    position: relative;
    margin-left: calc(${SCROLL_WIDTH});

    width: calc(100% - 4 * ${SCROLL_WIDTH});
    max-width: 1300px;
    padding: 3em 2em;
    border: 1px solid ${BLACK};
    border-radius: 1em;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .select {
        width: 20%;
        max-width: 230px;
    }

    p {
        color: ${WHITE};
    }

    @media(max-width: 950px) {
        flex-direction: column;
        padding: 1em 1em;

        height: 90%;
        max-height: 500px;
        overflow-y: auto; 

        max-width: 300px;

        .select {
            width: 100%;
            max-width: 230px;
        }

        p, input {
            font-size: 14px!important;
        }
    }
`

export {PlotGraphMenuStyled}